import Call from '../Call.v3';

import qs from 'querystring';

const AdkPartnerDomains = {
    get: async (filters = {}) => Call(`adk/partner_domains?${qs.stringify(filters)}`),
    remove: async (entity = {}) => Call(`adk/partner_domains/${entity.id}`, 'DELETE'),
    update: async (entity = {}) => Call(`adk/partner_domains`, 'PUT', entity),
    create: async (entity = {}) => Call(`adk/partner_domains`, 'POST', entity),
};

export default AdkPartnerDomains;



// WEBPACK FOOTER //
// ./src/services/API/components/AdkPartnerDomains.js